export enum TrashTypeEnum {
  Project = 0,
  Vcu = 1,
  Map = 2,
  Log = 3
}
